module.exports = __webpack_public_path__ + "img/3-4.234bdfb9.png";